module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.getDataTable()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Paciente")]), _vm._v(" "), _c('select-paciente', {
    on: {
      "setPacienteSelecionado": function (paciente) {
        _vm.setPacienteSelecionado(paciente);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Código da solicitação")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.codigo),
      expression: "filtros.codigo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtros.codigo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "codigo", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Solicitado de")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.dataInicial),
      expression: "filtros.dataInicial"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filtros.dataInicial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "dataInicial", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Até")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.dataFinal),
      expression: "filtros.dataFinal"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filtros.dataFinal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "dataFinal", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Situação da solicitação")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacao),
      expression: "filtros.situacao"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "situacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todas")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.MARCADA
    }
  }, [_vm._v("Marcada")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.EM_REGULACAO
    }
  }, [_vm._v("Em regulação")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.REGULADA
    }
  }, [_vm._v("Regulada")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.INFORMACAO_PENDENTE
    }
  }, [_vm._v("Informação pendente")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.INFORMACAO_ADICIONAL
    }
  }, [_vm._v("Informação adicional")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.NEGATIVADA
    }
  }, [_vm._v("Negativada")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.CONFIRMADA
    }
  }, [_vm._v("Confirmada")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.CANCELADA
    }
  }, [_vm._v("Cancelada")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.FALTA
    }
  }, [_vm._v("Falta")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.REALIZADA
    }
  }, [_vm._v("Realizada")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidade solicitante")]), _vm._v(" "), _c('select-unidade', {
    on: {
      "setUnidadeSelecionada": function (unidadeSelecionada) {
        _vm.setUnidadeSelecionada(unidadeSelecionada);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Regulado dia:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.dataRegulacao),
      expression: "filtros.dataRegulacao"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filtros.dataRegulacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "dataRegulacao", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Profissional solicitante")]), _vm._v(" "), _c('select-profissional', {
    attrs: {
      "tipo-profissional": "Solicitante"
    },
    on: {
      "setProfissionalSolicitanteSelecionado": function (profissional) {
        _vm.setProfissionalSolicitanteSelecionado(profissional);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Usuario marcador")]), _vm._v(" "), _c('select-usuario', {
    attrs: {
      "nivel": "marcador"
    },
    on: {
      "setUsuarioSelecionado": function (usuario) {
        _vm.setUsuarioSelecionado(usuario);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Profissional realizador")]), _vm._v(" "), _c('select-profissional', {
    attrs: {
      "tipo-profissional": "Realizador"
    },
    on: {
      "setProfissionalRealizadorSelecionado": function (profissional) {
        _vm.setProfissionalRealizadorSelecionado(profissional);
      }
    }
  })], 1)])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped table-hover"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "hand",
      on: {
        "click": function($event) {
          _vm.detalheSolicitacao(item)
        }
      }
    }, [_c('td', {
      attrs: {
        "width": "7%"
      }
    }, [_vm._v(_vm._s(_vm._f("formatarCodigo")(item.id)))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "7%"
      }
    }, [_vm._v(_vm._s(_vm._f("tipoAtendimento")(item.tipo_atendimento)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("tipoConsulta")(item.itens[0].tipo_consulta)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataHoraFormatada")(item.created_at)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.itens[0].contrato_procedimento.procedimento.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.paciente.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("sexo")(item.paciente.sexo)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.profissional.nome))]), _vm._v(" "), (item.itens[0].contrato_procedimento_atendimento) ? _c('td', [_vm._v(_vm._s(item.itens[0].contrato_procedimento_atendimento.profissional.nome))]) : _c('td', [_vm._v("SEM PROFISSIONAL")]), _vm._v(" "), (item.itens[0].contrato_procedimento_atendimento || item.itens[0].contrato_subgrupo_atendimento) ? _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.itens[0].contrato_procedimento_atendimento ? item.itens[0].contrato_procedimento_atendimento.data_atendimento : item.itens[0].contrato_subgrupo_atendimento.data_atendimento)) + " a partir das " + _vm._s(item.itens[0].contrato_procedimento_atendimento ? item.itens[0].contrato_procedimento_atendimento.hora_inicial : item.itens[0].contrato_subgrupo_atendimento.hora_inicial))]) : _c('td', [_vm._v("SEM DATA DEFINIDA")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.usuario.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("mesPorExtenso")(item.itens[0].contrato_procedimento.contrato.distribuicao.data_competencia)))]), _vm._v(" "), _c('td', [_c('strong', {
      class: _vm._f("situacaoSolicitacaoColor")(item.situacao)
    }, [_vm._v(_vm._s(_vm.verificarCancelamento(item)))])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 5,
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])])])])]), _vm._v(" "), _c('modal-detalhes-solicitacao', {
    attrs: {
      "solicitacao": _vm.solicitacao,
      "show": _vm.showModalDetalhesSolicitacao
    },
    on: {
      "close": function($event) {
        _vm.showModalDetalhesSolicitacao = false
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Verificação de atendimentos")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right"
  }, [_c('span', {
    staticClass: "fa fa-search"
  }), _vm._v(" Pesquisar")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Código da solicitação")]), _vm._v(" "), _c('th', [_vm._v("Tipo Atendimento")]), _vm._v(" "), _c('th', [_vm._v("Tipo Consulta")]), _vm._v(" "), _c('th', [_vm._v("Data da solicitação")]), _vm._v(" "), _c('th', [_vm._v("Procedimento")]), _vm._v(" "), _c('th', [_vm._v("Paciente")]), _vm._v(" "), _c('th', [_vm._v("Sexo")]), _vm._v(" "), _c('th', [_vm._v("Solicitante")]), _vm._v(" "), _c('th', [_vm._v("Realizador")]), _vm._v(" "), _c('th', [_vm._v("Data da realização")]), _vm._v(" "), _c('th', [_vm._v("Marcador")]), _vm._v(" "), _c('th', [_vm._v("Competência")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v("Situação")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-028b87ab"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atendimentos/verificacao/index.vue
// module id = 784
// module chunks = 0